const styles = {
  navigationSidepanel: {
    border: "solid 2px lightgrey",
    borderRadius: "5px"
  },
  titleItem: {
    cursor: "pointer",
    backgroundColor: "lightgrey",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between"
  },
  link: {
    color: "black",
    "&:hover": {
      color: "black",
    },
  },
};

export default styles;
